import { CoreEvent, eventNames } from '@carvana/core-events';

/**
 * Displays an error toast in the UI and triggers a DD action.
 * @param {string | null} message Text to display in the DD action and toast.
 */
export default function showApiError(message: string | null = null) {
  const errMessage = message
    ? message
    : 'We could not retrieve your updated terms. Please try again later.';

  CoreEvent.emit(eventNames.toasts.addToast, {
    title: 'Something went wrong',
    message: errMessage,
    priority: 'critical',
    delay: 8000
  });
}
